import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
	getCustomerGroupsTable,
	getProductGroupsTable,
	urls,
} from "./cgpgUtils";

const initialState = {
	isLoading: false,

	selectedView: "",

	countries: [],
	selectedCountry: "",
	selectedCountryID: "",
	CGPGAGlobalCountrtID:"",

	groupStatusList: [],
	selectedGroupStatus: "",

	searchText: "",

	periods: [],
	selectedPeriod: "",

	productGroups: null,
	productGroupsTable: null,

	customerGroups: null,
	customerGroupsTable: null,

   selectedRows: [],

   rejectMultiModalOpen: false, 
   rejectSingleModalOpen: false,
   rejectSelectedComment: "",
   navigatedCountryID: "",
   message: "",
   severity: "",
   messageOpen: false,
   selectedProductGroupName:"",
   selectedProductGroupID:0,

   selectedCustomerGroupName:"",
   selectedCustomerGroupID:0,

   clickedRowComment:"",
   groupRowClicked:false
};

export const getUserCountries = createAsyncThunk(
	"cgpgApproval/getUserCountries",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.userCountries + `userid=${data.userID}`;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getUserCountries", error);
		}
	}
);

export const getGroupStatus = createAsyncThunk(
	"cgpgApproval/getGroupStatus",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.groupStatus;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getGroupStatus", error);
		}
	}
);

export const getPeriods = createAsyncThunk(
	"cgpgApproval/getPeriods",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.periods;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getPeriods", error);
		}
	}
);

export const getProductGroups = createAsyncThunk(
	"cgpgApproval/getProductGroups",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.productGroups;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getProductGroups", error);
		}
	}
);

export const getCustomerGroups = createAsyncThunk(
	"cgpgApproval/getCustomerGroups",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.customerGroups;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getCustomerGroups", error);
		}
	}
);

export const rejectMultiplePG = createAsyncThunk(
	"cgpgApproval/rejectMultiplePG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.approveRejectMultiPG;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/rejectMultiplePG", error);
		}
	}
);
export const approveMultiplePG = createAsyncThunk(
	"cgpgApproval/approveMultiplePG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.approveRejectMultiPG;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/approveMultiplePG", error);
		}
	}
);

export const rejectMultipleCG = createAsyncThunk(
	"cgpgApproval/rejectMultipleCG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.approveRejectMultiCG;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/rejectMultipleCG", error);
		}
	}
);
export const approveMultipleCG = createAsyncThunk(
	"cgpgApproval/approveMultipleCG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.approveRejectMultiCG;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/approveMultipleCG", error);
		}
	}
);

export const rejectPG = createAsyncThunk(
	"cgpgApproval/rejectPG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.rejectApproveProductGroup;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/rejectPG", error);
		}
	}
);

export const approvePG = createAsyncThunk(
	"cgpgApproval/approvePG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.rejectApproveProductGroup;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/approvePG", error);
		}
	}
);

export const rejectCG = createAsyncThunk(
	"cgpgApproval/rejectCG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.rejectApproveCustomerGroup;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/rejectCG", error);
		}
	}
);
export const approveCG = createAsyncThunk(
	"cgpgApproval/approveCG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.rejectApproveCustomerGroup;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/approveCG", error);
		}
	}
);

const cgpgSlice = createSlice({
	name: "cgpgApproval",
	initialState,
	reducers: {
		setState: {
			prepare(name, value) {
				return {
					payload: { name, value },
				};
			},
			reducer(state, action) {
				const { name, value } = action.payload;
				state[name] = value;
			},
		},
		reset(state, { payload }) {
			if (payload === "refresh") {
			  state.isLoading = false;
			  state.selectedView="";
			  state.searchText = "";
			  state.selectedGroupStatus="";
			  if(state.CGPGAGlobalCountrtID===""){
			  state.selectedCountry = "";
			  state.selectedCountryID = "";
			  }
			  state.selectedPeriod = "";
			  state.selectedRows = [];
			  state.rejectMultiModalOpen = false;
			  state.rejectSingleModalOpen=false;
			  state.rejectSelectedComment = "";
			  state.productGroupsTable=null;
			  state.customerGroupsTable=null;
			  state.selectedProductGroupID=0;
			  state.selectedProductGroupName="";
			  state.selectedCustomerGroupID=0;
			  state.selectedCustomerGroupName="";
			  state.clickedRowComment="";
			  state.groupRowClicked=false;
			}
		  },
	},
	extraReducers: (builder) => {
		builder
			.addCase(getUserCountries.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getUserCountries.fulfilled, (state, action) => {
				state.countries = action.payload;
				state.isLoading = false;
			})
			.addCase(getUserCountries.rejected, (state, action) => {
				console.error(
					"cgpgApproval/getUserCountries",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(getGroupStatus.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getGroupStatus.fulfilled, (state, action) => {
				state.isLoading = false;
				state.groupStatusList = action.payload;
			})
			.addCase(getGroupStatus.rejected, (state, action) => {
				console.error("cgpgApproval/getGroupStatus", action.error.message);
				state.isLoading = false;
			})

			.addCase(getPeriods.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getPeriods.fulfilled, (state, action) => {
				state.periods = action.payload;
				state.isLoading = false;
			})
			.addCase(getPeriods.rejected, (state, action) => {
				console.error("cgpgApproval/getPeriods", action.error.message);
				state.isLoading = false;
			})

			.addCase(getProductGroups.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getProductGroups.fulfilled, (state, action) => {
				state.productGroups = action.payload;
				if(state.productGroups.length === 0){
					state.messageOpen = true;
					state.message = "No records found.";
					state.severity = "info";
					state.productGroupsTable=null;
					state.clickedRowComment="";
				  }
				  else{
					state.productGroupsTable = getProductGroupsTable(action.payload);
				  }
				
				state.isLoading = false;
			})
			.addCase(getProductGroups.rejected, (state, action) => {
				console.error(
					"cgpgApproval/getProductGroups",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(getCustomerGroups.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getCustomerGroups.fulfilled, (state, action) => {
				state.customerGroups = action.payload;
				if(state.customerGroups.length===0){
					state.messageOpen=true;
					state.message = "No records found.";
					state.severity = "info";
					state.customerGroupsTable=null;
					state.clickedRowComment="";
				}
				else{
					state.customerGroupsTable = getCustomerGroupsTable(action.payload);
				}				
				state.isLoading = false;
			})
			.addCase(getCustomerGroups.rejected, (state, action) => {
				console.error(
					"cgpgApproval/getCustomerGroups",
					action.error.message
				);
				state.isLoading = false;
			})
			.addCase(rejectMultiplePG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(rejectMultiplePG.fulfilled, (state, action) => {
				state.isLoading = false;
				if(action.payload!=0){
					state.messageOpen = true;
          			state.message = "Selected Productgroups Rejection Failed";
          			state.severity = "error";
				}
				else{
					state.messageOpen=true;
					state.message= "Selected Productgroups are Rejected Successfully";
					state.severity = "success";
				}
			})
			.addCase(rejectMultiplePG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/rejectMultiplePG",
					action.error.message
				);
				state.isLoading = false;
			})
			.addCase(approveMultiplePG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveMultiplePG.fulfilled, (state, action) => {
				state.isLoading = false;
				if(action.payload!=0){
					state.messageOpen = true;
          			state.message = "Selected Productgroups Approval Failed";
          			state.severity = "error";
				}
				else{
					state.messageOpen=true;
					state.message= "Selected Productgroups are Approved Successfully";
					state.severity = "success";
				}
			})
			.addCase(approveMultiplePG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/approveMultiplePG",
					action.error.message
				);
				state.isLoading = false;
			})
			.addCase(approveMultipleCG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveMultipleCG.fulfilled, (state, action) => {
				state.isLoading = false;
				if(action.payload!=0){
					state.messageOpen = true;
          			state.message = "Selected Customergroups Approval Failed";
          			state.severity = "error";
				}
				else{
					state.messageOpen=true;
					state.message= "Selected Customergroups are Approved Successfully";
					state.severity = "success";
				}
			})
			.addCase(approveMultipleCG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/approveMultipleCG",
					action.error.message
				);
				state.isLoading = false;
			})
			.addCase(rejectMultipleCG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(rejectMultipleCG.fulfilled, (state, action) => {
				state.isLoading = false;
				if(action.payload!=0){
					state.messageOpen = true;
          			state.message = "Selected Customergroups Rejection Failed";
          			state.severity = "error";
				}
				else{
					state.messageOpen=true;
					state.message= "Selected Customergroups are Rejected Successfully";
					state.severity = "success";
				}
			})
			.addCase(rejectMultipleCG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/rejectMultipleCG",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(rejectPG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(rejectPG.fulfilled, (state, action) => {
				state.isLoading = false;
				if(action.payload==0){
					state.messageOpen=true;
					state.message= "Productgroup Rejected Successfully";
					state.severity = "success";
				}
				else{
					state.messageOpen = true;
          			state.message = "Productgroup Rejection Failed";
          			state.severity = "error";
				}
			})
			.addCase(rejectPG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/rejectPG",
					action.error.message
				);
				state.isLoading = false;
				state.messageOpen = true;
        		state.message = "Productgroup Rejected Successfully";
        		state.severity = "success";
			})
			.addCase(approvePG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approvePG.fulfilled, (state, action) => {
				state.isLoading = false;
				if(action.payload!=0){
					state.messageOpen = true;
          			state.message = "Productgroup Approval Failed";
          			state.severity = "error";
				}
				else{
					state.messageOpen=true;
					state.message= "Productgroup Approved Successfully";
					state.severity = "success";
				}
			})
			.addCase(approvePG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/approvePG",
					action.error.message
				);
			})
			.addCase(approveCG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveCG.fulfilled, (state, action) => {
				state.isLoading = false;
				if(action.payload!=0){
					state.messageOpen = true;
          			state.message = "Customergroup Approval Failed";
          			state.severity = "error";
				}
				else{
					state.messageOpen=true;
					state.message= "Customergroup Approved Successfully";
					state.severity = "success";
				}
			})
			.addCase(approveCG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/approveCG",
					action.error.message
				);
			})
			

			.addCase(rejectCG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(rejectCG.fulfilled, (state, action) => {
				state.isLoading = false;
				if(action.payload===0){
					state.messageOpen=true;
					state.message= "Customergroup Rejected Successfully";
					state.severity = "success";
				}
				else{
					state.messageOpen = true;
          			state.message = "Customergroup Rejection Failed";
          			state.severity = "error";
				}
			})
			.addCase(rejectCG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/rejectCG",
					action.error.message
				);
			});
	},
});

export const { setState,reset } = cgpgSlice.actions;
export default cgpgSlice.reducer;
